import React, { useEffect, useState } from 'react'
import { Col, Form } from 'react-bootstrap'

import SpinerVeye from '../../../../components/spinnerVeye/spinnerVeye.js'
import { api_google } from '../../../../conexoes/google'
import { elipseVerde } from '../../../../utils/alternanciaIcones'
import { GOOGLE_MAPS_GEOCODING_API } from '../../../../utils/googleMapsApiKey'
import Mapa from '../../../googleMap/googleMapSemInfo'

export default function DadosCliente({
  logradourocliente: dsEndereco,
  bairrocliente: dsBairro,
  cidadecliente: dsCidade,
  ufcliente: dsEstado,
  cepcliente: dsCep,
  emailVendedorCliente: dsEmailCadastro,
  vendedorcliente: dsNome,
  telefoneVendedorCliente: dsTelefone,
  emailVendedorCliente: dsEmailContato
}) {
  const [spinAtivo, setSpinAtivo] = useState(false)
  const [dadosMapa, setDadosMapa] = useState()

  useEffect(() => {
    setSpinAtivo(true)

    async function geoCodeEndereco() {
      if (dsEndereco) {
        const enderecoFormatado = `${dsEndereco}, ${dsCidade}, BR`.replace(
          / /g,
          '+'
        )

        const { data } = await api_google.get(
          `/geocode/json?address=${enderecoFormatado}&key=${GOOGLE_MAPS_GEOCODING_API}`
        )
        setDadosMapa(data.results?.[0]?.geometry?.location)
      }
    }

    async function handleCarregarDadosCliente() {}

    geoCodeEndereco()
    handleCarregarDadosCliente()

    setSpinAtivo(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form>
      {spinAtivo && (
        <div className="componente-spinner-overlay">
          <div className="componente-spinner-container">
            <SpinerVeye />
          </div>
        </div>
      )}
      <div className="container-dados-cliente">
        <div className="container-dados-cliente-telas">
          <div className="container-dados-cliente-cadastro fundo-cor-7">
            <Form.Row>
              <Col>
                <img
                  className="icone-label-janela nao-selecionavel"
                  src={elipseVerde()}
                  alt="elipse"
                />
                <Form.Label>
                  <div className="fonte-cor-1 label-janela">Cadastro</div>
                </Form.Label>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col>
                <div className="caixa-detalhamento-cliente-1">
                  <div className="divisoria-detalhamento-cliente campo-select-divisor-cor-1" />
                  <Form.Row>
                    <Col>
                      <div className="grupo-detalhamento-cliente-1">
                        <div className="coluna-detalhamento-cliente-1">
                          <Form.Label className="fonte-cor-1 label-normal negrito">
                            Endereço:{' '}
                          </Form.Label>
                          <span className="fonte-cor-1 label-normal label-dados-cliente">
                            {' '}
                            {dsEndereco !== undefined &&
                            dsEndereco !== '' &&
                            dsEndereco !== null
                              ? dsEndereco
                              : '-'}
                          </span>
                        </div>
                        <div className="coluna-detalhamento-cliente-1">
                          <Form.Label className="fonte-cor-1 label-normal negrito">
                            Bairro:{' '}
                          </Form.Label>
                          <span className="fonte-cor-1 label-normal label-dados-cliente-2">
                            {' '}
                            {dsBairro !== undefined &&
                            dsBairro !== '' &&
                            dsBairro !== null
                              ? dsBairro
                              : '-'}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Form.Row>
                  <div className="divisoria-detalhamento-cliente campo-select-divisor-cor-1" />
                  <Form.Row>
                    <Col>
                      <div className="grupo-detalhamento-cliente-1">
                        <div className="coluna-detalhamento-cliente-1">
                          <Form.Label className="fonte-cor-1 label-normal negrito">
                            Estado:{' '}
                          </Form.Label>
                          <span className="fonte-cor-1 label-normal label-dados-cliente">
                            {' '}
                            {dsEstado !== undefined &&
                            dsEstado !== '' &&
                            dsEstado !== null
                              ? dsEstado
                              : '-'}
                          </span>
                        </div>
                        <div className="coluna-detalhamento-cliente-1">
                          <Form.Label className="fonte-cor-1 label-normal negrito">
                            Cidade:{' '}
                          </Form.Label>
                          <span className="fonte-cor-1 label-normal label-dados-cliente-2">
                            {' '}
                            {dsCidade !== undefined &&
                            dsCidade !== '' &&
                            dsCidade !== null
                              ? dsCidade
                              : '-'}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Form.Row>
                  <div className="divisoria-detalhamento-cliente campo-select-divisor-cor-1" />
                  <Form.Row>
                    <Col>
                      <div className="grupo-detalhamento-cliente-1">
                        <div className="coluna-detalhamento-cliente-1">
                          <Form.Label className="fonte-cor-1 label-normal negrito">
                            CEP:{' '}
                          </Form.Label>
                          <span className="fonte-cor-1 label-normal label-dados-cliente-3">
                            {' '}
                            {dsCep !== undefined &&
                            dsCep !== '' &&
                            dsCep !== null
                              ? dsCep
                              : '-'}
                          </span>
                        </div>
                        <div className="coluna-detalhamento-cliente-1">
                          <Form.Label className="fonte-cor-1 label-normal negrito">
                            E-mail:{' '}
                          </Form.Label>
                          <span className="fonte-cor-1 label-normal label-dados-cliente-2">
                            {' '}
                            {dsEmailCadastro !== undefined &&
                            dsEmailCadastro !== '' &&
                            dsEmailCadastro !== null
                              ? dsEmailCadastro
                              : '-'}
                          </span>
                        </div>
                      </div>
                    </Col>
                  </Form.Row>
                  <div className="divisoria-detalhamento-cliente campo-select-divisor-cor-1" />
                </div>
                <Form.Row>
                  <Col className="col-contato">
                    <img
                      className="icone-label-janela col-contato nao-selecionavel"
                      src={elipseVerde()}
                      alt="elipse"
                    />
                    <Form.Label>
                      <div className="fonte-cor-1 label-janela label-janela-contato ">
                        Contato
                      </div>
                    </Form.Label>
                  </Col>
                </Form.Row>
                <Form.Row>
                  <Col>
                    <div className="caixa-detalhamento-cliente-2">
                      <div className="divisoria-detalhamento-cliente campo-select-divisor-cor-1" />
                      <Form.Row>
                        <Col>
                          <div className="grupo-detalhamento-cliente-1">
                            <div className="coluna-detalhamento-cliente-2">
                              <Form.Label className="fonte-cor-1 label-normal negrito">
                                Nome do responsável:
                              </Form.Label>
                              <span className="fonte-cor-1 label-normal label-dados-cliente">
                                {' '}
                                {dsNome !== undefined &&
                                dsNome !== '' &&
                                dsNome !== null
                                  ? dsNome
                                  : '-'}
                              </span>
                            </div>
                          </div>
                        </Col>
                      </Form.Row>
                      <div className="divisoria-detalhamento-cliente campo-select-divisor-cor-1" />
                      <Form.Row>
                        <Col>
                          <div className="grupo-detalhamento-cliente-1">
                            <div className="coluna-detalhamento-cliente-1">
                              <Form.Label className="fonte-cor-1 label-normal negrito">
                                Telefone:
                              </Form.Label>
                              <span className="fonte-cor-1 label-normal label-dados-cliente-3">
                                {' '}
                                {dsTelefone !== undefined &&
                                dsTelefone !== '' &&
                                dsTelefone !== null
                                  ? dsTelefone
                                  : '-'}
                              </span>
                            </div>
                            <div className="coluna-detalhamento-cliente-1">
                              <Form.Label className="fonte-cor-1 label-normal negrito">
                                E-mail:
                              </Form.Label>
                              <span className="fonte-cor-1 label-normal label-dados-cliente-2">
                                {' '}
                                {dsEmailContato !== undefined &&
                                dsEmailContato !== '' &&
                                dsEmailContato !== null
                                  ? dsEmailContato
                                  : '-'}
                              </span>
                            </div>
                          </div>
                        </Col>
                      </Form.Row>
                      <div className="divisoria-detalhamento-cliente campo-select-divisor-cor-1" />
                    </div>
                  </Col>
                </Form.Row>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col>
                <div className="caixa-detalhamento-cliente-3">
                  <div className="container-dados-mapa">
                    {dadosMapa && (
                      <Mapa array={[dadosMapa]} tipo="localizacao" />
                    )}
                  </div>
                </div>
              </Col>
            </Form.Row>
          </div>
        </div>
      </div>
    </Form>
  )
}
